'use client';
import { faBars } from '@fortawesome/pro-solid-svg-icons';
import { FC, useState } from 'react';
import { Icon, IconButton } from '@/components/ui';
import useHeaderContent from '@/hooks/use-header-content';
import { useResolveThemeColor } from '@/hooks/use-resolve-theme-color';
import MobileMenuDrawer from './mobile-menu-drawer';

const MobileMenu: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const headerContent = useHeaderContent();
  const resolveThemeColor = useResolveThemeColor();
  const toolbarIconColor = resolveThemeColor(headerContent.mainRowTextColor ?? 'foreground');

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <IconButton
        aria-label="Open menu"
        className="block bg-transparent p-1.5 @lg:hidden"
        onClick={toggleDrawer}
      >
        <Icon icon={faBars} size="lg" style={{ color: toolbarIconColor }} />
      </IconButton>
      <MobileMenuDrawer isOpen={isOpen} toggleDrawer={toggleDrawer} />
    </>
  );
};

export default MobileMenu;
